module.exports = __webpack_public_path__ + "img/logo.d71674ae.png";